module.exports = __webpack_public_path__ + "static/img/reg-m.876d6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/reg-m.png
// module id = zy0S
// module chunks = 1